export default "__VITE_ASSET__BSFg_Zeq__"